import { legacyWebRouteMigration, type OperatorIdentity } from "@billiard/contracts";

type OperatorRole = OperatorIdentity["role"];

const reviewRoles = new Set<OperatorRole>(["OWNER", "MANAGER", "CASHIER"]);
const coachWorkspaceRoles = new Set<OperatorRole>(["OWNER", "MANAGER", "CASHIER", "COACH"]);

export function legacyRouteDestination(
  legacyPath: string,
  roles: readonly OperatorRole[],
): string | null {
  const migration = legacyWebRouteMigration(legacyPath);
  if (!migration || roles.length === 0) return null;

  if (migration.destination === "WORK_ITEMS") {
    if (roles.includes("WAITER")) return "/staff";
    return roles.some((role) => reviewRoles.has(role)) ? "/review?view=SERVICE" : null;
  }

  if (migration.destination === "COACH") {
    return roles.some((role) => coachWorkspaceRoles.has(role)) ? "/coach" : null;
  }

  return roles.some((role) => reviewRoles.has(role)) ? "/frontdesk" : null;
}

export function legacyRouteNavigationState(legacyPath: string): {
  legacyRouteMigration: { legacyPath: string; message: string };
} | null {
  const migration = legacyWebRouteMigration(legacyPath);
  if (!migration) return null;
  return {
    legacyRouteMigration: {
      legacyPath: migration.legacyPath,
      message: migration.message,
    },
  };
}
